export default "__VITE_ASSET__DPeOjDWd__"